
































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  deleteSearch,
  deleteSearchBulk, exportSearches,
  getSearches,
  getSearchesCount
} from '@/api/searches'
import {
  createFilter,
  dateFilter,
  getSortItems,
  personalFilter,
  prepareListFilters,
  searchFieldConcat,
  searchFieldConcatReverse,
  simpleSearchField,
  switchStateFilter,
  usersFilter
} from '@/utils/filter'
import Pagination from '@/components/Pagination/index.vue'
import ListToolbar from '@/components/ListToolbar/index.vue'
import FiltersDrawer from '@/components/Filter/FiltersDrawer.vue'
import {
  debounce,
  parseTime,
  getTranslations,
  hasPermission,
  successMsg,
  errorMsg,
  confirmDialog, numberFormat
} from '@/utils'
import { AppModule, DeviceType } from '@/store/modules/app'

@Component({
  name: 'searchList',
  components: {
    Pagination,
    ListToolbar,
    FiltersDrawer
  }
})

export default class extends Vue {
  private count = 0
  private total = 0
  private list = []
  private listLoading = true
  private showFilters = false
  private search = ''
  private selected: any = []
  private listQuery = createFilter()
  private debounceMethod = debounce(this.getList)
  private parseTime = parseTime
  private getTranslations = getTranslations
  private hasPermission = hasPermission
  private numberFormat = numberFormat

  private filters: any = []

  created() {
    this.getQueryParams()
    this.getList()
    if (hasPermission(['LIST_OTHERS_SEARCHES'])) {
      this.filters.push(personalFilter({
        key: 'user_id',
        label: 'filters.personalSearches'
      }))
      this.filters.push(usersFilter())
    }
  }

  get isMobile() {
    return AppModule.device === DeviceType.Mobile
  }

  private getQueryParams() {
    const query: any = this.$route.query || {}
    this.filters.push(dateFilter({
      from: query.from ? new Date(Number(query.from)) : null,
      to: query.to ? new Date(Number(query.to)) : null
    }))
    this.filters.push(switchStateFilter({
      key: 'active',
      label: 'filters.active',
      modelValue: query.active === true || query.active === 'true'
    }))
  }

  private async deleteItem(id: string) {
    if (!id) return
    const [data] = await confirmDialog('actions.apiDelete')
    if (!data) return
    try {
      await deleteSearch({ id })
      await successMsg('actions.apiDeleteSuccess')
      await this.getList()
    } catch (err) {
      await errorMsg('api.serverError')
    }
  }

  private handleSelectionChange(selected = []) {
    this.selected = selected
  }

  private handleSortChange(params: any = {}) {
    if (this.listQuery?.query?.sort) {
      this.listQuery.query.sort = getSortItems(params)
    }
    this.getList()
  }

  private async deleteItemsBulk() {
    if (!this.selected.length) return errorMsg('actions.selectItems')
    const [data] = await confirmDialog('actions.apiDeleteBulk')
    if (!data) return
    try {
      await deleteSearchBulk(this.selected.map((item: any) => {
        return item.id
      }))
      await successMsg('actions.apiDeleteBulkSuccess')
      await this.getList()
    } catch (err) {
      await errorMsg('api.serverError')
    }
  }

  private prepareFilters(filters: any) {
    prepareListFilters({
      listQuery: this.listQuery,
      withDefaultSort: true,
      filters: filters,
      search: this.search,
      searchFields: [
        searchFieldConcat('user.'),
        searchFieldConcatReverse('user.'),
        searchFieldConcat('client.'),
        searchFieldConcatReverse('client.'),
        simpleSearchField('meta>acreage_from'),
        simpleSearchField('meta>acreage_to'),
        simpleSearchField('meta>price_from'),
        simpleSearchField('meta>price_to'),
        simpleSearchField('meta>construction_year_from'),
        simpleSearchField('meta>construction_year_to')
      ],
      callback: () => {
        this.listQuery.options = {}
        try {
          if (this.$route.query.only_new_properties) {
            this.listQuery.options = {
              only_new_properties: true
            }
          }
        } catch (e) {}
      }
    })
  }

  private async filtersChanged(filters: any) {
    try {
      this.prepareFilters(filters)
      const { data } = await getSearchesCount(this.listQuery)
      this.count = data || 0
    } catch (err) {}
  }

  private submitFilters(filters: any) {
    this.filters = filters
    this.restartPaging()
    this.getList()
  }

  private redirectToEdit(id: any) {
    return this.$router.push('/search/edit/' + id)
  }

  private handleCommand(command: string) {
    switch (command) {
      case 'download': {
        exportSearches(this.list)
        break
      }
      case 'delete': {
        this.deleteItemsBulk()
        break
      }
      case 'filters': {
        this.count = this.total
        this.showFilters = true
        break
      }
    }
  }

  private restartPaging() {
    if (this.listQuery.query?.pagination) {
      this.listQuery.query.pagination.page = 1
    }
  }

  private async getList() {
    this.listLoading = true
    try {
      this.prepareFilters(this.filters)
      const { data } = await getSearches(this.listQuery)
      this.list = data.collection || []
      this.total = data.pagination.total_items || 0
      this.count = data.pagination.total_items || 0
    } catch (err) {}
    this.listLoading = false
  }

  onSearchChanged(search: string) {
    this.search = search
    this.restartPaging()
    this.debounceMethod()
  }
}
